import { useMutation, useQuery, useQueryClient } from 'react-query';
import request from 'src/api/utils';
import { UserStoreObject } from 'src/stores/UserStore';
import {
    FormOwnershipModel,
    FormOwnershipModelRules,
    FormOwnershipSettings,
} from 'common/lib/model/form/FormOwnership';

export interface FormOwnershipResponse {
    settings: FormOwnershipSettings;
    effectiveModels: FormOwnershipModelRules[];
    catalog: FormOwnershipModel[];
}

export function useFormOwnership() {
    const orgId = UserStoreObject.selectedOrg?.orgId;
    const key = ['formOwnership', orgId];
    const queryClient = useQueryClient();
    const query = useQuery<FormOwnershipResponse>({
        queryKey: key,
        queryFn: async () => (await request({ method: 'GET', url: 'organization/form-ownership' })).data,
        enabled: Boolean(orgId),
    });
    const mutation = useMutation<FormOwnershipResponse, Error, FormOwnershipSettings>({
        mutationFn: async (data) => (await request({ method: 'PUT', url: 'organization/form-ownership', data })).data,
        onSuccess: (data) => {
            queryClient.setQueryData(key, data);
        },
    });
    return { query, mutation, orgId };
}
